import React from "react";
import { Navigate } from "react-router-dom";
import { UserService } from "../../services/UserService";

const ProtectedRoute = ({ children }) => {
  if (!UserService.isLoggedIn || UserService.isUserTokenExpired) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

export default ProtectedRoute;
